import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResolverService } from '../__common/resolver.service';

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  private config: any = {};
  private storageKey = 'appConfig';
  private cacheDuration = 3600 * 1000; // 1 hour in milliseconds

  ADMIN_EMAIL = 'sebas';

  /* https://dashboard.voyjaleas.com/api-dashboard/config/apiConfig.php */

  constructor(private http: HttpClient,private resolver: ResolverService) {}

  loadConfig(): Promise<void> {

    return new Promise((resolve, reject) => {
      const cachedConfig = localStorage.getItem(this.storageKey);
      const cacheTime = localStorage.getItem(`${this.storageKey}_timestamp`);

      if (false && cachedConfig && cacheTime && (Date.now() - Number(cacheTime) < this.cacheDuration)) {
        console.log('Using cached config');
        this.config = JSON.parse(cachedConfig);
        resolve();
      } else {
        console.log('Fetching config from server');
        this.http.get('https://dashboard.voyjaleas.com/api-dashboard/config/apiConfig.php')
          .toPromise()
          .then(config => {
            this.config = config;
            localStorage.setItem(this.storageKey, JSON.stringify(config));
            localStorage.setItem(`${this.storageKey}_timestamp`, Date.now().toString());
            resolve();
          })
          .catch(error => {
            console.error("Error loading config:", error);
            reject(error);
          });
      }
    });
  }

  getApiUrl(key: string): string {
    return this.config[key] || '';
  }

  getAdminEmail(){
    return this.ADMIN_EMAIL;
  }
}
